import * as React from 'react';

import * as styles from './ReviewsDetails.css';

export const ReviewsDetails = (props: React.PropsWithChildren<{}>) => {
  return (
    <div data-testid="ReviewsDetails" className={styles['container']}>
      {props.children}
    </div>
  );
};
